import cloneDeep from 'lodash/cloneDeep'
import { GigOfferStages } from '@/constants/gig/gigOfferStages'
import { GigTimeTypes } from '@/constants/gig/gigTimeTypes'
import { convertToLocal } from '@/utils/date'

export default class GigOffer {
  id: number
  createdAt: Date
  deadline: number
  budget: string
  stage: GigOfferStages
  freelancerId: number
  customerId: number
  timeType: GigTimeTypes
  timeValue: number
  freelancerWallet: string

  constructor(data: Partial<GigOffer>) {
    Object.assign(this, cloneDeep(data))
  }

  static fromServer(data: LX.GigOffer) {
    return new GigOffer({
      id: data.id,
      createdAt: new Date(convertToLocal(data.created_at)),
      deadline: data.deadline,
      budget: data.rate,
      stage: data.stage,
      freelancerId: data.freelancer_id,
      customerId: data.customer_id,
      timeType: data.time_type,
      timeValue: data.time_value,
      freelancerWallet: data.freelancer_wallet,
    })
  }

  get deadlineInDays() {
    return (this.deadline || 0) / 86400
  }
}
